import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { Dialog, Autocomplete, Button } from '@totalsoft/rocket-ui';

const ModalTaskResponsibleSelect = ({ onAssignResponsible, onCloseModal, onAssignToMeResponsible, task, taskResponsibles }) => {
  const { t } = useTranslation();
  const [selectedResponsible, setResponsible] = useState(task.responsible ? task.responsible.id : null);

  const onResponsibleChange = value => {
    setResponsible(value);
  };

  return (
    <Dialog
      onClose={onCloseModal}
      open={true}
      fullWidth
      maxWidth={'sm'}
      title={<Typography variant='h5'>{t('TaskList.ModalTitle')}</Typography>}
      content={
        <Grid container>
          <Grid item xs={12}>
            <Autocomplete
              fullWidth
              value={selectedResponsible}
              onChange={onResponsibleChange}
              valueKey='id'
              simpleValue={true}
              options={taskResponsibles}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant='body1' gutterBottom>
              {t('TaskList.ModalDescription')}
            </Typography>
          </Grid>
        </Grid>
      }
      actions={
        <>
          <Button color='warning' fullWidth onClick={onAssignResponsible(selectedResponsible)}>
            {t('TaskList.Assign')}
          </Button>
          {task.canBeAssignedToMe && (
            <Button color='warning' fullWidth onClick={onAssignToMeResponsible(task)}>
              {t('TaskList.AssignToMe')}
            </Button>
          )}
          <Button color='warning' fullWidth onClick={onCloseModal}>
            {t('TaskList.Close')}
          </Button>
        </>
      }
    />
  );
};

ModalTaskResponsibleSelect.propTypes = {
  onAssignResponsible: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onAssignToMeResponsible: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  taskResponsibles: PropTypes.array.isRequired
};

export default ModalTaskResponsibleSelect;
